// session_timeout.js

(function() {
  var HEARTBEAT_INTERVAL = 15000; // 15 seconds for testing
  var HEARTBEAT_URL = "/heartbeat";
  var SIGN_IN_URL = "/accounts/sign_in";

  function checkSession() {
    console.log("Heartbeat ping at " + new Date().toISOString()); // Debug log

    fetch(HEARTBEAT_URL, { credentials: "same-origin" })
      .then(function(response) {
        console.log("Heartbeat response status:", response.status); // Debug log

        if (response.status === 401) {
          console.warn("Session expired, redirecting to sign-in...");
          window.location.href = SIGN_IN_URL;
        }
      })
      .catch(function(error) {
        console.error("Heartbeat failed:", error);
      });
  }

  setInterval(checkSession, HEARTBEAT_INTERVAL);
})();
